var React = require('react');

function Button (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"x":"40","y":"12","width":"208","height":"48","rx":"24","fill":"#404040","key":1}),React.createElement("rect",{"opacity":"0.06","x":"40","y":"140","width":"208","height":"48","rx":"24","fill":"#404040","key":2}),React.createElement("rect",{"x":"41","y":"77","width":"206","height":"46","rx":"23","stroke":"#404040","strokeWidth":"2","key":3})]);
}

Button.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Button;

Button.default = Button;
